const States = [
  { region: 'us-al', state: 'Alabama' },
  { region: 'us-ak', state: 'Alaska' },
  { region: 'us-az', state: 'Arizona' },
  { region: 'us-ar', state: 'Arkansas' },
  { region: 'us-ca', state: 'California' },
  { region: 'us-co', state: 'Colorado' },
  { region: 'us-ct', state: 'Connecticut' },
  { region: 'us-de', state: 'Delaware' },
  { region: 'us-diplomat', state: 'Diplomat' },
  { region: 'us-dc', state: 'District of Columbia' },
  { region: 'us-fl', state: 'Florida' },
  { region: 'us-ga', state: 'Georgia' },
  { region: 'us-hi', state: 'Hawaii' },
  { region: 'us-id', state: 'Idaho' },
  { region: 'us-il', state: 'Illinois' },
  { region: 'us-in', state: 'Indiana' },
  { region: 'us-ia', state: 'Iowa' },
  { region: 'us-ks', state: 'Kansas' },
  { region: 'us-ky', state: 'Kentucky' },
  { region: 'us-la', state: 'Louisiana' },
  { region: 'us-me', state: 'Maine' },
  { region: 'us-md', state: 'Maryland' },
  { region: 'us-ma', state: 'Massachusetts' },
  { region: 'us-mi', state: 'Michigan' },
  { region: 'us-mn', state: 'Minnesota' },
  { region: 'us-ms', state: 'Mississippi' },
  { region: 'us-mo', state: 'Missouri' },
  { region: 'us-mt', state: 'Montana' },
  { region: 'us-ne', state: 'Nebraska' },
  { region: 'us-nv', state: 'Nevada' },
  { region: 'us-nh', state: 'New Hampshire' },
  { region: 'us-nj', state: 'New Jersey' },
  { region: 'us-nm', state: 'New Mexico' },
  { region: 'us-ny', state: 'New York' },
  { region: 'us-nc', state: 'North Carolina' },
  { region: 'us-nd', state: 'North Dakota' },
  { region: 'us-oh', state: 'Ohio' },
  { region: 'us-ok', state: 'Oklahoma' },
  { region: 'us-or', state: 'Oregon' },
  { region: 'us-pa', state: 'Pennsylvania' },
  { region: 'us-ri', state: 'Rhode Island' },
  { region: 'us-sc', state: 'South Carolina' },
  { region: 'us-sd', state: 'South Dakota' },
  { region: 'us-tn', state: 'Tennessee' },
  { region: 'us-tx', state: 'Texas' },
  { region: 'us-ut', state: 'Utah' },
  { region: 'us-us', state: 'U.S. Government' },
  { region: 'us-vt', state: 'Vermont' },
  { region: 'us-va', state: 'Virginia' },
  { region: 'us-wa', state: 'Washington' },
  { region: 'us-wv', state: 'West Virginia' },
  { region: 'us-wi', state: 'Wisconsin' },
  { region: 'us-wy', state: 'Wyoming' },
];

const MexicoStates = [
  { region: 'mx-agu', state: 'Aguascalientes' },
  { region: 'mx-bcn', state: 'Baja California' },
  { region: 'mx-bcs', state: 'Baja California Sur' },
  { region: 'mx-cam', state: 'Campeche' },
  { region: 'mx-chp', state: 'Chiapas' },
  { region: 'mx-chh', state: 'Chihuahua' },
  { region: 'mx-cmx', state: 'Ciudad de México' },
  { region: 'mx-coa', state: 'Coahuila de Zaragoza' },
  { region: 'mx-col', state: 'Colima' },
  { region: 'mx-dur', state: 'Durango' },
  { region: 'mx-gua', state: 'Guanajuato' },
  { region: 'mx-gro', state: 'Guerrero' },
  { region: 'mx-hid', state: 'Hidalgo' },
  { region: 'mx-jal', state: 'Jalisco' },
  { region: 'mx-mic', state: 'Michoacán de Ocampo' },
  { region: 'mx-mor', state: 'Morelos' },
  { region: 'mx-mex', state: 'México' },
  { region: 'mx-nay', state: 'Nayarit' },
  { region: 'mx-nle', state: 'Nuevo León' },
  { region: 'mx-oax', state: 'Oaxaca' },
  { region: 'mx-pue', state: 'Puebla' },
  { region: 'mx-que', state: 'Querétaro' },
  { region: 'mx-roo', state: 'Quintana Roo' },
  { region: 'mx-slp', state: 'San Luis Potosí' },
  { region: 'mx-sin', state: 'Sinaloa' },
  { region: 'mx-son', state: 'Sonora' },
  { region: 'mx-tab', state: 'Tabasco' },
  { region: 'mx-tam', state: 'Tamaulipas' },
  { region: 'mx-tla', state: 'Tlaxcala' },
  { region: 'mx-ver', state: 'Veracruz de Ignacio de la Llave' },
  { region: 'mx-yuc', state: 'Yucatán' },
  { region: 'mx-zac', state: 'Zacatecas' },
];

const CanadaStates = [
  { region: 'ca-ab', state: 'Alberta' },
  { region: 'ca-bc', state: 'British Columbia' },
  { region: 'ca-mb', state: 'Manitoba' },
  { region: 'ca-nb', state: 'New Brunswick' },
  { region: 'ca-nf', state: 'Newfoundland' },
  { region: 'ca-ns', state: 'Nova Scotia' },
  { region: 'ca-nt', state: 'Northwest Territories' },
  { region: 'ca-on', state: 'Ontario' },
  { region: 'ca-pe', state: 'Prince Edward Island' },
  { region: 'ca-qc', state: 'Quebec' },
  { region: 'ca-sk', state: 'Saskatchewan' },
  { region: 'ca-yt', state: 'Yukon Territory' },
];

const CentralAmericanCountries = [
  { region: 'cac-bz', state: 'Belize' },
  { region: 'cac-cr', state: 'Costa Rica' },
  { region: 'cac-cz', state: 'Canal Zone' },
  { region: 'cac-sv', state: 'El Salvador' },
  { region: 'cac-gt', state: 'Guatemala' },
  { region: 'cac-hn', state: 'Honduras' },
  { region: 'cac-ni', state: 'Nicaragua' },
  { region: 'cac-pa', state: 'Panama' },
];

const EuropeanCountries = [
  { region: 'eu-al', state: 'Albania' },
  { region: 'eu-ad', state: 'Andorra' },
  { region: 'eu-at', state: 'Austria' },
  { region: 'eu-by', state: 'Belarus' },
  { region: 'eu-be', state: 'Belgium' },
  { region: 'eu-ba', state: 'Bosnia and Herzegovina' },
  { region: 'eu-bg', state: 'Bulgaria' },
  { region: 'eu-hr', state: 'Croatia' },
  { region: 'eu-cy', state: 'Cyprus' },
  { region: 'eu-cz', state: 'Czech Republic' },
  { region: 'eu-dk', state: 'Denmark' },
  { region: 'eu-diplomat', state: 'Diplomat' },
  { region: 'eu-ee', state: 'Estonia' },
  { region: 'eu-fi', state: 'Finland' },
  { region: 'eu-fr', state: 'France' },
  { region: 'eu-de', state: 'Germany' },
  { region: 'eu-gr', state: 'Greece' },
  { region: 'eu-hu', state: 'Hungary' },
  { region: 'eu-is', state: 'Iceland' },
  { region: 'eu-ie', state: 'Ireland' },
  { region: 'eu-it', state: 'Italy' },
  { region: 'eu-xk', state: 'Kosovo' },
  { region: 'eu-lv', state: 'Latvia' },
  { region: 'eu-li', state: 'Liechtenstein' },
  { region: 'eu-lt', state: 'Lithuania' },
  { region: 'eu-lu', state: 'Luxembourg' },
  { region: 'eu-mt', state: 'Malta' },
  { region: 'eu-md', state: 'Moldova' },
  { region: 'eu-mc', state: 'Monaco' },
  { region: 'eu-me', state: 'Montenegro' },
  { region: 'eu-nl', state: 'Netherlands' },
  { region: 'eu-mk', state: 'North Macedonia' },
  { region: 'eu-no', state: 'Norway' },
  { region: 'eu-pl', state: 'Poland' },
  { region: 'eu-pt', state: 'Portugal' },
  { region: 'eu-ro', state: 'Romania' },
  { region: 'eu-ru', state: 'Russia' },
  { region: 'eu-sm', state: 'San Marino' },
  { region: 'eu-rs', state: 'Serbia' },
  { region: 'eu-sk', state: 'Slovakia' },
  { region: 'eu-si', state: 'Slovenia' },
  { region: 'eu-es', state: 'Spain' },
  { region: 'eu-se', state: 'Sweden' },
  { region: 'eu-ch', state: 'Switzerland' },
  { region: 'eu-tr', state: 'Turkey' },
  { region: 'eu-ua', state: 'Ukraine' },
  { region: 'eu-gb', state: 'United Kingdom' },
  { region: 'eu-va', state: 'Vatican City' },
];

const Protectorates = [
  { region: 'us-as', state: 'American Samoa' },
  { region: 'us-gu', state: 'Guam' },
  { region: 'us-mp', state: 'Northern Mariana Islands' },
  { region: 'us-pr', state: 'Puerto Rico' },
  { region: 'us-um', state: 'U.S. Minor Outlying Islands' },
  { region: 'us-vi', state: 'Virgin Islands' },
];

export const Regions = [
  { label: 'United States', states: States },
  { label: 'Mexico', states: MexicoStates },
  { label: 'Canada', states: CanadaStates },
  { label: 'Europe', states: EuropeanCountries },
  { label: 'Central American', states: CentralAmericanCountries },
  { label: 'American Possessions or Protectorates', states: Protectorates },
];
